import { REFERENCE_RATE_UNIT_DECIMALS, REFERENCE_RATE_UNIT_SCALE } from 'src/features/referenceRates/utils/constants';
import { REFERENCE_RATE_UNIT } from 'src/features/referenceRates/utils/types';

/** Rates read before the backend gained `unit` are money rates. */
const resolveUnit = (unit?: REFERENCE_RATE_UNIT | null) => unit ?? REFERENCE_RATE_UNIT.CURRENCY;

/** A typed decimal ("103.5") is accepted for a unit when it has no more decimals than the unit stores. */
export const getReferenceRateValuePattern = (unit?: REFERENCE_RATE_UNIT | null) =>
    new RegExp(`^\\d*\\.?\\d{0,${REFERENCE_RATE_UNIT_DECIMALS[resolveUnit(unit)]}}$`);

/** Decimal as typed -> the integer the API stores. Returns null for anything that is not a number. */
export const toReferenceRateMinorUnits = (value: string, unit?: REFERENCE_RATE_UNIT | null): number | null => {
    const numeric = parseFloat(value);
    if (isNaN(numeric)) return null;

    return Math.round(numeric * REFERENCE_RATE_UNIT_SCALE[resolveUnit(unit)]);
};

/** The stored integer -> the plain decimal number it represents (35000 percent -> 3.5). */
export const fromReferenceRateMinorUnits = (amount: number, unit?: REFERENCE_RATE_UNIT | null): number =>
    amount / REFERENCE_RATE_UNIT_SCALE[resolveUnit(unit)];

/** The stored integer -> an editable string, without trailing zeros ("103.5", not "103.5000"). */
export const formatReferenceRateInputValue = (amount: number, unit?: REFERENCE_RATE_UNIT | null): string =>
    String(Number(fromReferenceRateMinorUnits(amount, unit).toFixed(REFERENCE_RATE_UNIT_DECIMALS[resolveUnit(unit)])));
